export default __webpack_public_path__ + "static/project-slide-6-992-765-1311cabe2e569801a855e0cf7af6d7f1.webp";